import { z } from 'zod';

import i18n from '@/i18n';

export const RequestLoginSchema = z.object({
    email: z.string().email(i18n.global.t('Vinaliga skriva ein rættan teldubústað.')),
    password: z.string().min(6, i18n.global.t('Kotan skal vera 6 tekin.')),
});
